import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const SuperAdminEntryPoint: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SuperAdminEntryPoint" */ '../src/SuperAdminEntryPoint.js'
			)
		).SuperAdminEntryPoint,
});
